import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e252a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#fff"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\" data-v-08e252a8><g transform=\"translate(1 1)\" stroke-width=\"2\" data-v-08e252a8><circle stroke-opacity=\".4\" cx=\"18\" cy=\"18\" r=\"18\" data-v-08e252a8></circle><path d=\"M36 18c0-9.94-8.06-18-18-18\" data-v-08e252a8><animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 18 18\" to=\"360 18 18\" dur=\"1s\" repeatCount=\"indefinite\" data-v-08e252a8></animateTransform></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}